import { render, staticRenderFns } from "./FormulateInputTextColor.vue?vue&type=template&id=5dd9d7ab&lang=pug&"
import script from "./FormulateInputTextColor.vue?vue&type=script&lang=ts&"
export * from "./FormulateInputTextColor.vue?vue&type=script&lang=ts&"
import style0 from "./FormulateInputTextColor.vue?vue&type=style&index=0&id=5dd9d7ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports